import { useContext, useEffect, useState } from "react";

import Input from "shared/Input/Input";

import { ArrowRightIcon, ArrowSmallLeftIcon, ChatBubbleLeftRightIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonCircle from "shared/Button/ButtonCircle";
import { requestAPI } from "utils/api";
import { UIContext } from "contexts/UIContext";
import { GlobalDataContext } from "contexts/GlobalData";

import CommentListing from "./CommentListing";
import SigninForm from "components_custom/SigninForm/SigninForm";

const fieldEmptyCheck = (text : string) => {
	//공백이 있으면 true
	
	const regex = /^\s*$/;

	// console.log(text === '');
	// console.log(text === null);
	// console.log(text === undefined);
	// console.log();

	if (text === '' || text === null || text === undefined || regex.test(text)) {
	  return "HasEmpty";     
	}
	
	return 'NoEmpty';
}

const CommentList = ({
	info,
	agencyNo,
	no
}: any) => {

	const {
		toast,
		modal,
	} = useContext (UIContext);  
	
	const { 
		initData
	} = useContext (GlobalDataContext);

	const [chatList, setChatList] = useState <[]> ([]);
	const [commentContents, setCommentContents] = useState ("");


	console.log(">>> 1", no)
	console.log(">>> 1", agencyNo)

	const load = async () => {
		const res2: any = await requestAPI('GET', `v1/comment/product/${no}`, null);

		setChatList(res2.data.list);
	};

	useEffect (() => {
		load();
	}, [])


	const handleCommentSaveRequest = async () => {

		if (initData.token_info.permission_group === "guest") {
			
			modal({
				title: "로그인", 
				contents: <SigninForm modalSw={true} />,
				buttons: []
			});	

			return toast ({
				type: 'warning', 
				contents: '로그인이 필요해요'
			});
		}
		
		let isEmpty = fieldEmptyCheck(commentContents);
		
		if (isEmpty === "HasEmpty") {
			return toast ({
				type: 'warning', 
				contents: '내용을 입력해 주세요.'
			});
		}

		const res_info: any = await requestAPI ('POST', `v1/comment/product/${no}`, {
			title: info.title,
			agencyNo,
			commentContents,
		});

		if (res_info.code === 1000) {
			toast ({
				type: 'success', 
				contents: "글이 추가 되었어요"
			});

			setCommentContents("");
			load();
		}		
	};

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
		
		const formattedTime2 = `${(hours < 10?"0":"")}${hours}:${minutes}`;

		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}.${month}.${day}`;
		
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			time2: formattedTime2,
			year: year,
			month: month,
			day: day,
		};
	};

	return (
		<div id="comments" className="listingSection__wrap space-y-0 p-0">
			{/* HEADING */}
			<div className="pl-5 pt-5">
				<h2 className="text-lg sm:text-2xl font-semibold">질문</h2>
				<div className="pt-3 w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
			</div>
			{/* Content */}
			<div className="pt-5 pb-5 pl-5 pr-5">
				
				<div className="relative">
					<Input
						value={commentContents}
						onChange={e => setCommentContents(e.target.value)}
						fontClass=""
						sizeClass="h-16 px-4 py-3"
						rounded="rounded-3xl"
						placeholder="질문 또는 후기를 남겨주세요..."
					/>
					<ButtonCircle
						onClick={() => handleCommentSaveRequest()}
						className="absolute right-2 top-1/2 transform -translate-y-1/2"
						size=" w-12 h-12 "
					>
						<ArrowRightIcon className="w-5 h-5" />
					</ButtonCircle>
				</div>
			</div>

			{/* comment */}
			<div className="divide-y divide-neutral-100 dark:divide-neutral-800 bg-white p-3 rounded-2xl">
				{
					(chatList.length > 0)
					?
						chatList.map((item: any, idx: number) => (
							<CommentListing
								key={`chatlist_${idx}`}
								className={"py-8"}
								data={item}
								date={formatKoreanDate(item.createdAt).date}
								load={load}
							/>
						))
					:
						<div>아직 코멘트가 없어요</div>
				}
				
			{/* 
				<div className="pt-8">
					<ButtonSecondary>View more 20 reviews</ButtonSecondary>
				</div> 
			*/}
			</div>
		</div>
	);
};

export default CommentList;
